/* eslint-disable */
// source: pricing_disclosure.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest', null, global);
goog.exportSymbol('proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.displayName = 'proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.displayName = 'proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    freeTrial: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest;
  return proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFreeTrial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeTrial();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool free_trial = 1;
 * @return {boolean}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.prototype.getFreeTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest} returns this
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureRequest.prototype.setFreeTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pricingDisclosure: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse;
  return proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPricingDisclosure(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPricingDisclosure();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string pricing_disclosure = 1;
 * @return {string}
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.prototype.getPricingDisclosure = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse} returns this
 */
proto.billing.public.company.pricingdisclosure.GetMockedPricingDisclosureResponse.prototype.setPricingDisclosure = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.billing.public.company.pricingdisclosure);
